import { pathPatternToRegex } from '@utils'
import { paths } from 'mmfintech-backend-api'

export const NAVIGATION_ROW_HEIGHT = 56

export const pathsToHidePaymentButtons = (param: string) => [
  //TO BE ADDED
  paths.settings(),
  paths.banking.deposit(),
  paths.banking.send(),
  pathPatternToRegex(`${paths.banking.send()}/*`),
  paths.banking.batchPayment(),
  paths.expenseManagement.dashboard(),
  paths.expenseManagement.reports(),
  paths.expenseManagement.reportDetails(param),
  paths.expenseManagement.counterparties(),
  paths.expenseManagement.counterpartyDetails(param),
  paths.expenseManagement.payments(param),
  paths.invoices.create(),
  paths.invoices.upload(),
  paths.invoices.uploadEdit(param),
  paths.invoices.add(),
  paths.invoices.edit(param),
  paths.invoices.send(param),

  paths.banking.exchange(),

  paths.cards.list(),
  paths.onboarding.questionnaireKyb(),

  paths.invoicesCustomersWrapper() + paths.invoices.list(),
  paths.invoicesCustomersWrapper() + paths.customers(),
  paths.userManagement(),
  paths.developer(),
  paths.ibanIssuing(),
  paths.ibanIssuingPreview(),
  paths.scanAndPay(),
  paths.p2pQrCode(),

  paths.userDepartmentManagement(),
  `${paths.userDepartmentManagement()}/departments`,
  `${paths.userDepartmentManagement()}/users`
]

export const pathsToShowOnlyMobilePaymentButtons = [
  paths.invoicesCustomersWrapper() + paths.invoices.list(),
  paths.invoicesCustomersWrapper() + paths.customers()
]

export const pathsToShowBottomBorder = (param: string) => [
  paths.ibanIssuing(),
  paths.ibanIssuingPreview(),
  paths.scanAndPay(),
  paths.p2pQrCode(),
  paths.banking.deposit(),
  paths.banking.send(),
  paths.banking.sendPix(),
  paths.banking.sendToCard(),
  paths.banking.sendInterac(),
  paths.banking.sendPerfectMoney(),
  paths.banking.sendInternalTransfer(),
  paths.banking.sendBankTransfer(),
  paths.banking.sendDigitalWallet(),
  paths.banking.sendToLinkedAccount(),
  paths.banking.sendIntraAccountTransfer(),
  paths.banking.sendTo(':recipientId'),
  paths.banking.sendCrypto(),
  paths.banking.sendBatchPayment(),
  paths.banking.exchange(),
  paths.invoices.create(),
  paths.invoices.upload(),
  paths.invoices.uploadEdit(param),
  paths.invoices.add(),
  paths.invoices.send(param),
  paths.invoices.edit(param)
]

export const pathsToIncreaseHeight = [
  //TO BE ADDED
  paths.onboarding.questionnaireKyb()
]
